export default __webpack_public_path__ + "static/media/115a0e043fc0511fc1ec4e76f2763ec5.xml";